const rad = function (x) {
    return x * Math.PI / 180;
};

export function calculateDistance(originLat, originLng, destinationLat, destinationLng) {
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = rad(destinationLat - originLat);
    var dLong = rad(destinationLng - originLng);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(originLat)) * Math.cos(rad(destinationLat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
}

export function createDirectionsUrl(station, userLocation) {
    if (station && station.latitude && station.longitude) {
        var url = 'https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=' + station.latitude + ',' + station.longitude;
        if (userLocation && userLocation != null) {
            url += '&origin=' + userLocation.latitude + ',' + userLocation.longitude;
        }
        return url;
    } else {
        return null;
    }
}